module.exports = __webpack_public_path__ + "static/23-72f2921f3f5aff78797a59d717a4135d.jpg";